import React, { useState } from 'react';
import OrderNotifications from '../shared/OrderNotifications';
import ConfirmDialog from '../shared/ConfirmDialog';
import { AppBar, Toolbar, IconButton, Tooltip, Box, Typography, Avatar, Stack } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import LogoutIcon from '@mui/icons-material/Logout';
import { DRAWER_RAIL_WIDTH } from './drawerComponent';

const AppBarComponent = ({ onDrawerOpen, onLogout, user, role, onNotificationSelect }) => {
  const [logoutOpen, setLogoutOpen] = useState(false);
  const profile = user?.data || user;
  return (
    <><AppBar position="fixed" elevation={0} sx={{ width: { md: `calc(100% - ${DRAWER_RAIL_WIDTH}px)` }, ml: { md: `${DRAWER_RAIL_WIDTH}px` }, bgcolor: 'background.paper', color: 'text.primary', borderBottom: '1px solid', borderColor: 'divider' }}>
      <Toolbar sx={{ minHeight: { xs: 64, md: 72 }, gap: 2 }}>
        <IconButton aria-label="Open navigation" onClick={onDrawerOpen} edge="start" sx={{ display: { md: 'none' } }}><MenuIcon /></IconButton>
        <Typography variant="body2" color="text.secondary" sx={{ flex: 1 }}>BBG / Workspace</Typography>
        <Stack direction="row" alignItems="center" spacing={1.5}>
          <OrderNotifications role={role} onSelect={onNotificationSelect} />
          <Avatar sx={{ width: 34, height: 34, bgcolor: 'primary.light', color: 'primary.main', fontSize: 14 }}>{profile?.admin_name?.charAt(0) || 'U'}</Avatar>
          <Box sx={{ display: { xs: 'none', sm: 'block' } }}><Typography variant="body2" fontWeight={650}>{profile?.admin_name || 'Account'}</Typography><Typography variant="caption" color="text.secondary" sx={{ textTransform: 'capitalize' }}>{role?.replace(/_/g, ' ')}</Typography></Box>
          <Tooltip title="Sign out"><IconButton aria-label="Sign out" onClick={() => setLogoutOpen(true)}><LogoutIcon fontSize="small" /></IconButton></Tooltip>
        </Stack>
      </Toolbar>
    </AppBar>
    <ConfirmDialog open={logoutOpen} title="Sign out of BBG Admin?" description="You’ll return to the sign-in page. Sign in again to access your workspace." confirmText="Sign out" cancelText="Stay signed in" variant="default" onCancel={() => setLogoutOpen(false)} onConfirm={() => onLogout?.()} />
    </>
  );
};
export default AppBarComponent;
